import React, { useId } from 'react';

import Text from '~/components/core/TextComponents/Text';

interface CardLabelProps {
  children: string;
}

/** What a value on a card is: a payload field's name, "Rejection reason", "Your answer". */
export const CardLabel: React.FC<CardLabelProps> = ({ children }) => (
  <Text variant={Text.VARIANTS.XS} weight={Text.WEIGHTS.SEMI_BOLD} colorVariant={Text.COLOR_VARIANTS.SECONDARY}>
    {children}
  </Text>
);

interface LabelledTextProps {
  label: string;
  /** The value the label names. */
  children: React.ReactNode;
}

/** A value under the label that says what it is, read out as one group named by the label. */
const LabelledText: React.FC<LabelledTextProps> = ({ label, children }) => {
  const labelId = useId();

  return (
    <div role="group" aria-labelledby={labelId} className="flex flex-col gap-4">
      <span id={labelId}>
        <CardLabel>{label}</CardLabel>
      </span>
      {children}
    </div>
  );
};

export default LabelledText;
